const hostname = window && window.location && window.location.hostname
console.log('Detected host: ' + hostname)

let redirectUrl;
let loginUrl;
if(hostname.includes('ukcr-dev.home-np.oocl.com')) {
  redirectUrl = 'https://gbcr-app-ui-uk-dev-dooclh.home-np.oocl.com/login?tokenId=';
  loginUrl = 'https://ukcr-dev.home-np.oocl.com/api/admin/login';
} else if(hostname.includes('ukcr-int.home-np.oocl.com')) {
  redirectUrl = 'https://gbcr-app-ui-uk-int-dooclh.home-np.oocl.com/login?tokenId=';
  loginUrl = 'https://ukcr-int.home-np.oocl.com/api/admin/login';
} else if(hostname.includes('ukcr.home.oocl.com')) {
  redirectUrl = 'https://newukcr.digital.oocl.com/login?tokenId=';
  loginUrl = 'https://ukcr.home.oocl.com/api/admin/login';
} else {
  redirectUrl = 'https://gbcr-app-ui-uk-int-dooclh.home-np.oocl.com/login?tokenId=';
  loginUrl = 'http://localhost:3000/api/admin/login';
}
export const GBCRUrl = redirectUrl;
export const loginApi = loginUrl;
